export default "__VITE_ASSET__LZflPTGq__"